// Wire frames for the cross-host `host-exec` mode.
//
// After a `mode: "host-exec"` hello is accepted, the accept side streams these
// JSON frames back to the dialer over the encrypted relay channel (one frame
// per `ch.send(JSON.stringify(frame))`). The relay's encrypted channel
// UTF-8-decodes valid-UTF-8 payloads to a STRING on the receiving side, so the
// dialer parses each inbound string as a frame.
//
// Output bytes are base64-encoded so arbitrary (possibly non-UTF-8) stdout/
// stderr survives the JSON round-trip intact.

import { z } from "zod";

export const hostExecFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("stdout"), dataB64: z.string() }),
  z.object({ type: z.literal("stderr"), dataB64: z.string() }),
  z.object({
    type: z.literal("exit"),
    code: z.number().nullable(),
    signal: z.string().nullable(),
  }),
  z.object({ type: z.literal("error"), message: z.string() }),
]);

export type HostExecFrame = z.infer<typeof hostExecFrameSchema>;

// Default + hard cap for a single exec invocation.
export const HOST_EXEC_DEFAULT_TIMEOUT_MS = 120_000;
export const HOST_EXEC_MAX_TIMEOUT_MS = 120_000;

// Cap on total captured output (stdout + stderr combined) before we kill the
// child and report truncation. Protects the daemon (and the agent reading the
// result) from an unbounded command.
export const HOST_EXEC_MAX_OUTPUT_BYTES = 1024 * 1024; // 1 MB
